// extracted by mini-css-extract-plugin
module.exports = {"second":"Rest_second__3Sy9P"};